const basicAnimalBrowserController = 'ProhlizecZvirat';
const comprehensiveAnimalBrowserController = 'KomplexniSeznam';

/** Permission codes required for the basic animal-browser screens. */
export const basicAnimalBrowserPermissions = {
    superUser: `${basicAnimalBrowserController}/PPSuperUzivatel`,
    breeder: `${basicAnimalBrowserController}/PPJakoChovatel`,
    authorizedOrganization: `${basicAnimalBrowserController}/PPOpravnenaOrganizace`,
    bullSelectorH: `${basicAnimalBrowserController}/BullSelector_H`,
    bullSelectorC: `${basicAnimalBrowserController}/BullSelector_C`,

};

/** Permission codes required for the comprehensive animal-browser screens. */
export const comprehensiveAnimalBrowserPermissions = {
    superUser: `${comprehensiveAnimalBrowserController}/KSSuperuzivatel`,
    breeder: `${comprehensiveAnimalBrowserController}/KSChovatel`,
    authorizedOrganization: `${comprehensiveAnimalBrowserController}/KSOpravnenaOrganizace`,
};
